
import PowerAppService from "@/apis.machine/PowerAppService";
import DtoTreePower from "@/models.machine/DtoTreePower";
import DtoTreeSearchPower from "@/models.machine/DtoTreeSearchPower";
import { EnumMenuSceneOption } from "@/models.machine/EnumMenuScene";
import { EnumUiDragType } from "@/models.machine/EnumUiDragType";
import UiTreeDrag from "@/models.machine/UiTreeDrag";
import MiezzButton from "@/models/MiezzButton";
import MiezzModal from "@/models/MiezzModal";
import router from "@/router";
import { ElMessage } from "element-plus";
import { Vue, Options } from "vue-class-component";
import PowerDetail from "./PowerDetail.vue";
import PowerForm from "./PowerForm.vue";
@Options({
  components: {
    PowerForm,
    PowerDetail,
  },
})
export default class PowerTree extends Vue {
  models: DtoTreePower[] = [];
  dto: any = new DtoTreeSearchPower();
  /**绑定属性 */
  props = {
    value: "Id",
    label: "Name",
    children: "Children",
    class: (data: any, node: any) => {
      return "tree-node";
    },
  };

  modalDetail = new MiezzModal();
  modalForm = new MiezzModal();

  select = new DtoTreePower();

  id?: string;
  path?: string;

  EnumMenuSceneOption = EnumMenuSceneOption;
  topButtons: MiezzButton[] = [];

  created(): void {
    this.topButtons = [
      {
        Code: "curpm",
        Label: "公司/用户/职能/权限/菜单查询",
        Icon: "search",
        Type: "default",
        Size: "small",
      },
      {
        Code: "add",
        Label: "添加",
        Icon: "plus",
        Type: "primary",
        Size: "small",
      },
    ];

    this.modalDetail.Width = "80%";
    this.modalForm.Width = "80%";

    const query = router.currentRoute.value.query;
    for (const key in query) {
      this.dto[key] =
        key == "OnlyShowCheck" ? query[key] == "true" : query[key];
    }
    this.handleGet();
  }

  /**事件-获取 */
  handleGet(): void {
    /**路由地址追加分页参数 */
    const current = router.currentRoute.value;
    for (const key in this.dto) {
      current.query[key] = this.dto[key];
    }
    router.push({
      path: current.path,
      params: current.params,
      query: current.query,
      force: true,
    });
    PowerAppService.GetTree(this.dto).then((r) => {
      if (r.data.Data) this.models = r.data.Data;
    });
  }

  /**事件-单选搜索 */
  handleRadioSearch(): void {
    this.handleGet();
  }

  /**顶部按钮点击 */
  handleTopButtonClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "curpm":
        this.$router.push("/sys/power/curpm");
        complete();
        break;
      case "add":
        this.modalForm.Show = true;
        this.modalForm.Title = "新增权限";
        this.id = undefined;
        this.path = "/";
        complete();
        break;
      default:
        break;
    }
  }

  handleNodeClick(data: DtoTreePower): void {
    this.modalDetail.Show = true;
    this.modalDetail.Title = `权限详细-${data.Name}`;
    this.select = data;
    this.id = this.select.Id;
    this.path = undefined;
  }

  /**表单提交 */
  handleSubmit(): void {
    this.modalForm.Show = false;
    this.handleGet();
  }

  /**删除 */
  handleDelete(): void {
    this.modalDetail.Show = false;
    this.handleGet();
  }

  handleDrop(
    draggingNode: any,
    dropNode: any,
    dropType: string,
    ev: any
  ): void {
    const dragging: DtoTreePower = draggingNode.data;
    const drop: DtoTreePower = dropNode.data;
    const dto = new UiTreeDrag<string>();
    dto.DraggingId = dragging.Id;
    dto.DraggingParentId = dragging.ParentId;
    dto.DropId = drop.Id;
    dto.DropParentId = drop.ParentId;
    dto.DragType =
      dropType == "before"
        ? EnumUiDragType.Before
        : dropType == "after"
        ? EnumUiDragType.After
        : EnumUiDragType.Inner;
    PowerAppService.DragSort(dto).then((r) => {
      ElMessage.success("排序成功");
      this.handleGet();
    });
  }
}
